import { useLocation } from "react-router-dom";
import { Seo } from "./seo";
import { useOfferings } from "../offerings/use-offerings";
import { findPublicSeoPage } from "../seo/site-seo";

/**
 * Applies per-route <title>, <meta description>, and canonical for every public
 * page — including product pages rendered by offering plugins, which cannot
 * import the website's <Seo> component directly. Mirrors <SiteStructuredData>:
 * one mount in the layout drives SEO tags off the current pathname.
 *
 * Pages that are not part of the public set (dashboards, admin, unknown routes)
 * return null here and manage their own <Seo> (e.g. NotFoundPage sets noindex).
 */
export function SitePageSeo() {
  const { pathname } = useLocation();
  const { offerings } = useOfferings();
  const page = findPublicSeoPage(pathname, offerings);

  if (!page) {
    return null;
  }

  return <Seo title={page.title} description={page.description} />;
}
